import BarChartIcon from '@mui/icons-material/BarChart';
import PieChartIcon from '@mui/icons-material/PieChart';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import TableChartIcon from '@mui/icons-material/TableChart';
import TimelineIcon from '@mui/icons-material/Timeline';

import { VEGA_LITE_CHART_KEYS } from '../../../../constants/aiAnalytics';

export const TABLE_DISPLAY_TYPE = 'table';

export const CHART_TYPES = [
  { value: 'bar', label: 'Bar', Icon: BarChartIcon },
  { value: 'line', label: 'Line', Icon: ShowChartIcon },
  { value: 'area', label: 'Area', Icon: TimelineIcon },
  { value: 'pie', label: 'Pie', Icon: PieChartIcon },
  { value: 'scatter', label: 'Scatter', Icon: ScatterPlotIcon },
  { value: 'table', label: 'Table', Icon: TableChartIcon }
];

const MARK_TO_TYPE = {
  bar: 'bar',
  line: 'line',
  area: 'area',
  arc: 'pie',
  point: 'scatter',
  circle: 'scatter',
  square: 'scatter'
};

export function parseSpec(spec) {
  if (!spec) {
    return null;
  }
  if (typeof spec === 'string') {
    try {
      return JSON.parse(spec);
    } catch (_) {
      return null;
    }
  }
  return spec;
}

export function isVegaLiteSpec(spec) {
  const parsed = parseSpec(spec);
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return false;
  }
  return VEGA_LITE_CHART_KEYS.some(key => key in parsed);
}

export function buildTableSpec() {
  return JSON.stringify({ displayType: TABLE_DISPLAY_TYPE });
}

export function isTableSpec(spec) {
  return parseSpec(spec)?.displayType === TABLE_DISPLAY_TYPE;
}

export function detectChartType(spec) {
  const parsed = parseSpec(spec);
  if (!parsed) {
    return null;
  }
  if (parsed.displayType === TABLE_DISPLAY_TYPE) {
    return TABLE_DISPLAY_TYPE;
  }
  const mark = parsed?.mark ?? parsed?.layer?.[0]?.mark;
  const markName = typeof mark === 'string' ? mark : mark?.type;
  return markName ? MARK_TO_TYPE[markName] || null : null;
}

export function chartTypeLabel(spec) {
  const type = detectChartType(spec);
  const entry = CHART_TYPES.find(t => t.value === type);
  return entry ? entry.label : 'Chart';
}
